"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RequireAuth_1 = __importDefault(require("@Components/RequireAuth"));
const navigation_1 = __importDefault(require("@App/navigation"));
const RegistrationQuestionnaire_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RegistrationQuestionnaire"));
const react_router_dom_1 = require("react-router-dom");
const RightsholderRegistrationLayout_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout"));
const RightsholderRegistrationForm_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm"));
const route_1 = require("@App/navigation/route");
const createRegistrationMemberRoutes = () => ({
    path: route_1.REGISTRATION_MEMBER_ROUTE,
    element: (react_1.default.createElement(RequireAuth_1.default, null,
        react_1.default.createElement(RightsholderRegistrationLayout_1.default, null))),
    children: [
        {
            path: route_1.FORM_SEGMENT,
            element: react_1.default.createElement(RightsholderRegistrationForm_1.default, null),
        },
        {
            path: route_1.QUESTIONNAIRE_ROUTE,
            element: react_1.default.createElement(RegistrationQuestionnaire_1.default, null),
        },
        {
            path: '',
            element: react_1.default.createElement(react_router_dom_1.Navigate, { to: navigation_1.default.registrationRightsholder.form(), replace: true }),
        },
    ],
});
exports.default = createRegistrationMemberRoutes;
